import { cn } from "@/lib/utils";
import { Link } from "@tanstack/react-router";

type AppFooterLink = {
  label: string;
  to: string;
};

type AppFooterProps = {
  links?: AppFooterLink[];
  className?: string;
};

export function AppFooter({ links, className }: AppFooterProps) {
  const year = new Date().getFullYear();
  // Built in render (CR-267): wuchale drops strings in module-scope variable
  // initializers, so a module-level default would stay English under fr/de.
  const footerLinks = links ?? [
    { label: "Privacy policy", to: "/privacy" },
    { label: "Terms of use", to: "/terms" },
  ];

  return (
    <footer
      className={cn(
        "text-muted-foreground flex w-full justify-center gap-4 border-t py-6 text-xs",
        className,
      )}
    >
      <span>© {year} Kairo SAS</span>

      {footerLinks.map(({ label, to }) => (
        <Link key={to} to={to} className="underline underline-offset-2">
          {label}
        </Link>
      ))}
    </footer>
  );
}
